import * as ReactDOM from 'react-dom';
import { IColumns, StoreFuncs, getRandomId } from "../../ExcelStore";
import InputCellType from "./InputCellType";
import { FieldTypeName, dotPngImg, getInputValue, getHreflink, linkedColor } from "./FieldCellType";
import $ from 'jquery';
import { get } from 'lodash';
import DatePicker from '../coms/date-picker';
import TimePicker from '../coms/time-picker';
const datePng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAACA0lEQVR42r1UTWsUQRBdFTVENIJRPHhUQQX9AeIH5mIUj+uCXsZDBt21s93VH9Xdl0G8REEPgl7EX2AUv8AcQsg/8Og93tT/oPU22bgJI9FdSMOD4tWrN101NdNobMdRSu11zu37Wx45aP7Vb4fx8ap2fK+uCBxy0EBbd5sD2qcnFNLiAL4KVgRLm/jFNW5lTbPOmxCfwqvRSekQ+fjBeH5kmG/pEG5L8pWIPusYC3CDIHAhLpiQX/Y5G/Jj0X+EV8/QhPTacp7ut6xMutD1sSlnz+aOwEmuJV2d73Myguvk0/y6od1o+N9Hu7zRUFp+Z3301vLFYUCcgrT8/o/h6qC/C74NA+nwBzwGbzjfpdjqdGSehs8Q5aluN58tSzvZbvujxqRLAOI7Sh2+T3wOGmhRI/UteQ9vamdobGxTyF9kJqEoijFZ4iPy9GUpWEZcVNWY4RShkbd9FzWohUetoeX0UOJfgmdlWY6rEI4R558A4rKqxsX8+aomPdjScNb7E9rytNbhVFVVO3HLWQpTAGJZm13K2tPQGGOOb2moHN+Qdl8Yxzexc1rrg1hcAHGzWfX2EBqsy/a3rJ27AiGRvyaGu/F9yvAZQAwOXwY02sXLtYbk81tyPENEJ4eCSzPw6BmGEPaTi3PW50+jgEKcg1fvZ1CWPGGtnRwFzDxR+38c9fwG1BL+KX3/T+MAAAAASUVORK5CYII=';
const dateTimePng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAACwElEQVR42p1UTW9MYRQeRbUNbSqthopuSIREQiKxKaUWxkYiJoiISRdXZ8ad+35/jbpI0AURId1ZsJG0XVSUIiIlNixIWFlIWfsRPO9trtZMRzre5OS+H+c8555znnMymb9XUxiqzcNCbMjUWXEcr+K80hdo3VFXIQh0B+e8ywuRrkSldum5WiilvUQ5S7g5E4Zht7/Dtx1QKxJASs1WLu0NLt20F6bsVybtXHquFrzNMO3m8P28YGPiMIzbE0Ah3C4m7GMmjBXCHGLSPIDylN8vJZzrLHSm4Pg2Y2qQaS24dtNhaLv/AHJlJwBy1J8jrvcT7rL1chgEwWoqzRFC5J55e3P4n4CNriUB4XGaKnuXKjfcqAiEXguozEv84Qfk5WnDIs0MRVF1SqPqkIeUWkcrlV6vADqs8fvQ2m5Pr5SrhUKhkxC38YJSmwrGdA4svNUCgoMGnn8SYUbLTB30e6bca6pHdqIgXZHQ56nSE0jTC67Mc6RqAhEOR5HraQxQ2n6A3AfAO8g53A1SKg9waU7D9gm4eMdHt+yQ8a6g96Vc1lt82GiGa+Av8x3CmNkNx28jaU7WABJmhvA4GwlF8vl8i7/zvc09E4Q+laaKaTuGKK4HcdyWOJbW+OLWAArlroIGv2BwLwjiNn8XcrsDBrOlUqVvMSDCfA+7MQAVibIn0JI/agA5N3uhXEB++gcG5qvHud3u/7pclttSwCSnKIbX9bagTw463zKREJ7Yz5Doh+jnERTlEkKJ4X0kOXMdYfXAaJIIxaoaxU+YplwutxK6owCdzCTjSNpbQH+1lMDZo2KxuJYodZYp/Z0ptQ+cbE4RAdaMFGFg2I9+Diy7Zz0IqHIZoX6CXCHcHkeRjiGii3D8hkrH8/m4paFBkEU1fb6Qu5tEmnEAjRPwj2CkJRz834UwW33LIV3rIa2L334DaBD72Y619JMAAAAASUVORK5CYII=';
const timePng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAACX0lEQVR42pVUTWsUQRBdyUaIqNGc/DrG+IEokruueo16Wi9GBA8T3Lg7Xd3T1d0TYY4i7uZqklUiKGgQ79F41B8ghuTv+GpgN5vNuLtpKOjp7npV86pelUoDVhRF4/V6/SRRNiUmezkrHXZFkZtUib9LNqTK+o/E4ZtYvrcubej0DoAnRwKrKb4C53fE/oe2rqXYP6HEPRSTvbahRdZvKRvWFrWeGQhW1/omHHblccPai9VqdaL/jZwt6jBDnLYBvNNI0muFYC9MuKyt30VmzUqlUu4GEQ45PK1Ze6b3/exsNG6sX9YctiX4PjCl1ClEe0+JX+0FywGZLxhOf2rnbvQnIaDwayOJVQncvdCc3iMXthb6Iw0BzH3Bo/CNAt7ucHIUlXupjHtTJZo4LCDBB1kuw2yWZWVwlAlHn5Thx4WFGgKYg4JjoewZ84mSNKzh8FUl7v7/AEHJb3LukYB2DJlN7VEWHqCgn597f1pSFsCNGIeF1Wc+B37+IItfwnPHYmvncH2kA4j7jTwII03j0nVEnS8CBMdj6IKztLR0vteglGOdN0aan8MHwcr1igw8JdykgqIMW+KjXWjBuKvzXLcofaNxsG2GLWkb/PJ3YFT2hoFzk5DcGhn/Fp9jo8NVyvBbEdvX2LJyfUKbsQ2vhLehUFAUqHptbPhbI5oufBQnyXWIfgfDYWVhwHDQCJ7/EfvtujFXB0aOY76Eh21yfhPabmqXzsN5Tvq0O77Yb0rQGvnpkZgRPoRkODGG6rr0GIj/ImpANZPYuVsHOBuJcvAkcvJQgFgty473T6P+9Q9W+EKJ8/a2MwAAAABJRU5ErkJggg==';
const dateImg = document.createElement('img');
dateImg.src = datePng;
const dateTimeImg = document.createElement('img');
dateTimeImg.src = dateTimePng;
const timeImg = document.createElement('img');
timeImg.src = timePng;

export enum DateTimeType {
    Date = '2',
    Time = '19',
    DateTime = '290'
}
const getImg = (type): HTMLImageElement | undefined => {
    if (type === DateTimeType.Date) {
        return dateImg;
    } else if (type === DateTimeType.Time) {
        return timeImg;
    } else if (type === DateTimeType.DateTime) {
        return dateTimeImg;
    }
    return undefined;
}
export default (column: IColumns, editable: boolean) => {
    if (editable) {
        const { type } = column;
        class Type extends GC.Spread.Sheets.CellTypes.Base {
            div: HTMLDivElement;
            showTime: boolean;
            img: HTMLImageElement | undefined;
            formater: string;
            instance;
            itemWidth = {};
            constructor() {
                super();
                this.showTime = type === DateTimeType.DateTime;
                this.img = getImg(type);
                this.formater = type === DateTimeType.DateTime ? 'yyyy-MM-dd HH:mm' : type === DateTimeType.Date ? 'yyyy-MM-dd' : 'HH:mm';
            }
            paint(ctx: CanvasRenderingContext2D, value: any, x: number, y: number, w: number, h: number, style: GC.Spread.Sheets.Style, context?: any) {
                try {
                    ctx.clearRect(x, y, w, h);
                    const realValue = getInputValue(value);
                    if (!editable && getHreflink(value)) {
                        style.foreColor = linkedColor;
                        style.textDecoration = GC.Spread.Sheets.TextDecorationType.underline;
                        const { row } = context;
                        this.itemWidth[row] = parseInt(ctx.measureText(realValue).width.toString());
                    }
                    super.paint(ctx, realValue, x, y, w - 20, h, style, context);
                    if (this.img) {
                        //ctx.save();
                        const width = Math.min(16, h);
                        ctx.drawImage(this.img, x + w - width, y + (h - width) / 2, width, width);
                        // ctx.restore();
                    }
                    if (editable) {
                        const { sheet, row, col } = context;
                        if (get(sheet.modifyedValues, `${StoreFuncs.getRandomId(row)}.${col}`)) {
                            ctx.drawImage(dotPngImg, x, y, 8, 8);
                        }
                    }

                } catch (e) {
                }
            }
            getAutoFitWidth(value: any, text: string, cellStyle: GC.Spread.Sheets.Style, zoomFactor: number, context?: any): number {
                return super.getAutoFitWidth(getInputValue(value), text, cellStyle, zoomFactor, context) + (editable ? 20 : 0);
            }
            getHitInfo(x: number, y: number, cellStyle: GC.Spread.Sheets.Style, cellRect: GC.Spread.Sheets.Rect, context?: any): GC.Spread.Sheets.IHitTestCellTypeHitInfo {
                const { row, col, sheetArea, sheet } = context;
                const info = {
                    x,
                    y,
                    row,
                    col,
                    cellRect,
                    sheetArea,
                    sheet,
                    isReservedLocation: editable ? cellRect.x + cellRect.width - x < 20 : x - cellRect.x <= this.itemWidth[row]
                } as any;
                return info;
            }
            processMouseMove(hitInfo: GC.Spread.Sheets.IHitTestCellTypeHitInfo) {
                const { sheet, isReservedLocation } = hitInfo as any;
                var div = sheet.getParent().getHost();
                var canvasId = div.id + "vp_vp";

                var canvas = $("#" + canvasId)[0];
                if (sheet && isReservedLocation) {
                    canvas.style.cursor = 'pointer';
                    return true;
                } else {
                    canvas.style.cursor = 'default';
                }
                return false;
            };
            processMouseUp(hitInfo: GC.Spread.Sheets.IHitTestCellTypeHitInfo): boolean {
                const { sheet, row, col, cellRect, sheetArea, isReservedLocation } = hitInfo as any;
                if (isReservedLocation) {
                    if(editable) {
                        this.openPicker(sheet.getCell(row, col, sheetArea), cellRect);
                    } else {
                        const hreflink = getHreflink(sheet.getValue(row, col, sheetArea));
                        if (hreflink) {
                            (window as any).cubeOpenHreflinkFromExcel(hreflink);
                        }
                    }
                   
                    return true;
                }

                return super.processMouseUp(hitInfo);
            }
            openPicker = (context: GC.Spread.Sheets.CellRange, cellRect: GC.Spread.Sheets.Rect) => {
                const { sheet, row, col } = context;
                if (!this.div) {
                    this.div = document.createElement('div');
                    const host = sheet.getParent().getHost();
                    host.appendChild(this.div);
                    this.div.style.visibility = 'hidden';
                }
                $(this.div).css({
                    position: 'absolute',
                    left: cellRect.x,
                    top: cellRect.y,
                    width: cellRect.width,
                    height: cellRect.height,
                });
                if (!this.instance) {
                    const value = context.value();
                    const unmountDatePicker = () => {
                        if (this.div) {
                            ReactDOM.unmountComponentAtNode(this.div);
                            this.instance = void 0;
                        }
                    }
                    const changeValue = (newValue) => {
                        sheet.suspendPaint();
                        const value = context.value();
                        let newValueSpan = '';
                        const hreflink = getHreflink(value);
                        newValueSpan = JSON.stringify({ hreflink, value: newValue });
                        const dataSource = sheet.getDataSource();
                        const datas = dataSource.getValue("datas");
                        const data = datas[row];
                        data[column.column] = newValue;
                        data[`${column.column}span`] = newValueSpan;
                        (sheet as any).setChangedValue(getRandomId(data), column, { sheet, row, col, newValue: newValueSpan, oldValue: value,time:data.time });
                        sheet.resumePaint();
                    }
                    if (type === DateTimeType.Date || type === DateTimeType.DateTime) {
                        ReactDOM.render(
                            <DatePicker
                                showTime={type === DateTimeType.DateTime}
                                ref={ref => this.instance = ref}
                                style={{ height: '100%', width: '100%' }}
                                onChange={changeValue}
                                onClose={unmountDatePicker}
                                value={getInputValue(value)}
                                formatter={type === DateTimeType.DateTime ? 'yyyy-MM-dd HH:mm' : 'yyyy-MM-dd'}
                            />, this.div);
                    } else {
                        ReactDOM.render(<TimePicker
                            ref={(ref) => this.instance = ref}
                            value={getInputValue(value)}
                            onChange={changeValue}
                            style={{ height: '100%', width: '100%' }}
                            onClose={unmountDatePicker}
                        ></TimePicker>, this.div);
                    }
                }
                const openModal = () => {
                    if (this.instance) {
                        this.instance.openModal();
                    } else {
                        setTimeout(() => {
                            openModal();
                        }, 50);
                    }
                }
                openModal();

            }
        }
        return Type;
    } else {
        return InputCellType({ ...column, typeName: FieldTypeName.Text });
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/stores/list/excel/celltypes/DateTimeCellType.tsx